"use client";

const SectionWrapper = ({ 
  variant = "light",        // light | dark | gradient | pattern
  children,
  className = "py-20",
  containerClassName = "max-w-6xl mx-auto px-6",
  ...props 
}) => {
  const backgroundClasses = {
    light: "bg-[var(--bg-secondary)]",
    dark: "bg-[var(--bg-primary)]",
    gradient: "bg-gradient-to-br from-[var(--bg-secondary)] to-[var(--bg-primary)]",
    pattern: "bg-[var(--bg-secondary)] relative"
  };

  return (
    <section className={`${backgroundClasses[variant]} ${className}`} {...props}>
      <div className={containerClassName}>
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;